import { Box, Grid, Stack, SxProps, Theme, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export function TransportationCard({
  companyLogo,
  flightNumber,
  company,
  departureTime,
  arrivalTime,
  departureDate,
  arrivalDate,
  departure,
  arrival,
}: {
  companyLogo?: string;
  flightNumber?: string;
  company?: string;
  departureTime?: string;
  departureDate: string;
  departure: string;
  arrivalTime?: string;
  arrivalDate: string;
  arrival: string;
}) {
  const { t } = useTranslation();
  const gridItemStyles: SxProps<Theme> = {
    borderBottom: (t) => `1px solid ${t.palette.grey[200]}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  const formatTime = (timeString: string) => {
    if (!timeString) {
      return '';
    }
    const [hours, minutes] = timeString.split(':').slice(0, 2);
    return `${hours}:${minutes}`;
  };
  return (
    <Grid container spacing={0}>
      {(companyLogo || flightNumber || company) && (
        <Grid item xs={12} md={3} sx={gridItemStyles}>
          <Cell header>
            <Typography>{t('transportCard.flight')}</Typography>
          </Cell>
          <Cell>
            <Stack direction="row" spacing={1}>
              {companyLogo && (
                <img src={companyLogo} height={24} alt="company logo" />
              )}
              <Typography sx={{ mt: 2 }}>{flightNumber}</Typography>
            </Stack>
            <Typography sx={{ mt: 1 }} color="GrayText">
              {company}
            </Typography>
          </Cell>
        </Grid>
      )}
      <Grid item xs={12} md={3} sx={gridItemStyles}>
        <Cell header>
          <Typography>{t('transportCard.departure')}</Typography>
        </Cell>
        <Cell>
          {departureTime && (
            <Typography fontWeight="600">
              {formatTime(departureTime)}
            </Typography>
          )}
          <Typography>
            {new Date(`${departureDate}`)
              .toLocaleString('tr-TR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                weekday: 'long',
              } as Intl.DateTimeFormatOptions)
              .toString()}
          </Typography>
          <Typography color="GrayText">{departure}</Typography>
        </Cell>
      </Grid>
      <Grid item xs={12} md={3} sx={gridItemStyles}>
        <Cell header>
          <Typography>{t('transportCard.arrival')}</Typography>
        </Cell>
        <Cell>
          {arrivalTime && (
            <Typography fontWeight="600">{formatTime(arrivalTime)}</Typography>
          )}
          <Typography>
            {new Date(`${arrivalDate}`)
              .toLocaleString('tr-TR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                weekday: 'long',
              } as Intl.DateTimeFormatOptions)
              .toString()}
          </Typography>
          <Typography color="GrayText">{arrival}</Typography>
        </Cell>
      </Grid>
      {departureTime && arrivalTime && (
        <Grid item xs={12} md={3} sx={gridItemStyles}>
          <Cell header>
            <Typography>{t('transportCard.duration')}</Typography>
          </Cell>
          <Cell>
            <Typography fontWeight="600">-</Typography>
          </Cell>
        </Grid>
      )}
    </Grid>
  );
}

function Cell(props: { header?: boolean; children?: React.ReactNode }) {
  return (
    <Box
      sx={{
        mt: props.header ? 1 : 0,
        py: 1,
        px: 2,
        ...(props.header
          ? {
              color: 'grey',
            }
          : {}),
      }}
    >
      {props.children}
    </Box>
  );
}
